<template>
    <div class="company-component-table">
        <el-table
            :data="tableData"
            height="200"
            border>
            <el-table-column
                v-for="item in config.tableList"
                :key="item.prop"
                :prop="item.prop"
                :show-overflow-tooltip="item.tooltip"
                :label="item.label">
            </el-table-column>
            <el-table-column
                :label="$translate('lang.E3202103160009', { defaultText: '注册状态' })"
                width="150">
                <template slot-scope="scope">
                    <span :style="{color:scope.row.registerStatus==='N'?'red':''}">
                    {{scope.row.registerStatus==='Y'?$translate('lang.E3202102260004', { defaultText: '启用' }):$translate('lang.E3202102260003', { defaultText: '停用' })}}
                    </span>
                </template>
             </el-table-column>
        </el-table>
    </div>
</template>
<script>
import config from './companyPrefix.js';
export default {
    props: {
        tableData: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            config: config
        };
    }
};
</script>
<style lang="less">
.company-component-table{
   .el-table--border {
        border: 1px solid #EBEEF5;
    }
}
</style>